import LocationDetails from "../../../components/LocationDetails";

const LocationDetailsPage = () => {
    return <LocationDetails />
}
export default LocationDetailsPage;
